import { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AnalyticsFlowEvent } from "@rapid/analytics/types";
import { useAnalytics } from "@rapid/contexts/AnalyticsContext";
import { ImproveLayout } from "./Layout";
import { ImproveSidebarContent } from "./SidebarContent";
import { ImproveVisualAreaContent } from "./VisualAreaContent";
import { useFlowState } from "@rapid/hooks/useFlowState";
import { useClearImproveState, useClearMediaState } from "@rapid/store";
import { DeploySteps, Flows } from "@rapid/types/flows";
import { FullScreenModal } from "@rapid/components/flow/shared/FullScreenModal";

export function ImproveModal() {
    const navigate = useNavigate();
    const { track } = useAnalytics();
    const { computeUrlPath } = useFlowState();
    const clearImproveState = useClearImproveState();
    const clearMediaState = useClearMediaState();

    const handleClose = useCallback(
        (source: "button" | "escape") => {
            track({ event: AnalyticsFlowEvent.IMPROVE_MODAL_CLOSED, data: { source } });
            // Always navigate to the deploy page for the current workflow
            const deployPath = computeUrlPath({ flow: Flows.DEPLOY, step: DeploySteps.DEPLOY });
            navigate(deployPath);
        },
        [navigate, computeUrlPath, track]
    );

    // Clear improve and media state when unmounting (leaving the page)
    useEffect(() => {
        return () => {
            clearImproveState();
            clearMediaState();
        };
    }, [clearImproveState, clearMediaState]);

    return (
        <FullScreenModal
            title="Improve Model"
            description="When you approve an image, it will be used to improve your model. Edit any boxes before approving."
            onClose={() => handleClose("button")}
            showHeaderBorder={false}
        >
            <ImproveLayout
                Sidebar={<ImproveSidebarContent />}
                VisualArea={<ImproveVisualAreaContent />}
            />
        </FullScreenModal>
    );
}
